import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { AuthProvider, useAuth } from './contexts/AuthContext'
import Layout from './components/Layout/Layout'
import LoginPage from './pages/Auth/LoginPage'
import Dashboard from './pages/Dashboard/Dashboard'
import UserManagement from './pages/Users/UserManagement'
import UserDetails from './pages/Users/UserDetails'
import TransactionManagement from './pages/Transactions/TransactionManagement'
import ProviderManagement from './pages/Providers/ProviderManagement'
import RentalManagement from './pages/Rentals/RentalManagement'
import SystemSettings from './pages/Settings/SystemSettings'
import LoadingPage from './components/UI/LoadingPage'

// Route guards
const PublicRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  
  if (isLoading) return <LoadingPage />
  return !isAuthenticated ? children : <Navigate to="/dashboard" replace />
}

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  
  if (isLoading) return <LoadingPage />
  return isAuthenticated ? children : <Navigate to="/login" replace />
}

function AppContent() {
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          } 
        />
        
        {/* Protected Routes */}
        <Route 
          path="/*" 
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  {/* Dashboard */}
                  <Route path="/dashboard" element={<Dashboard />} />
                  
                  {/* User Management */}
                  <Route path="/users" element={<UserManagement />} />
                  <Route path="/users/:userId" element={<UserDetails />} />
                  
                  {/* Transaction Management */}
                  <Route path="/transactions" element={<TransactionManagement />} />
                  
                  {/* Rental Management */}
                  <Route path="/rentals" element={<RentalManagement />} />
                  
                  {/* Provider Management */}
                  <Route path="/providers" element={<ProviderManagement />} />
                  
                  {/* System Settings */}
                  <Route path="/settings" element={<SystemSettings />} />
                  
                  {/* Default Redirect */}
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Box>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App